module.exports = __webpack_public_path__ + "img/music-note.07830bb4.svg";